import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { allLegalDocuments } from "content-collections";
import { z } from "zod";
import { MarketingShell } from "@/components/misc/marketing-layout";
import { isLegalDocumentModuleEnabled } from "@/lib/modules";

export const Route = createFileRoute("/_marketing/legal/$slug")({
	component: () => (
		<MarketingShell>
			<Outlet />
		</MarketingShell>
	),
	beforeLoad: ({ params }) => {
		const slug = z.string().parse(params.slug);
		const hasDocument = allLegalDocuments.some(
			(document) =>
				document.documentId === slug &&
				isLegalDocumentModuleEnabled(document.module),
		);
		if (!hasDocument) {
			throw redirect({ to: "/legal" });
		}
	},
});
